import { Input, Select, Row, Col, Segmented } from "antd";
import {
  STATUS_OPTIONS,
  LISTING_FILTER_OPTIONS,
  SHOW_IN_LISTINGS_COPY,
} from "../../commons/events.helpers";
import useAuthStore from "stores/AuthStore/AuthStore";

const TIME_OPTIONS = [
  { label: "All", value: "ALL" },
  { label: "Upcoming", value: "UPCOMING" },
  { label: "Past", value: "PAST" },
];

function EventsFilterBar({
  search,
  onSearchChange,
  statusFilter,
  onStatusChange,
  listingFilter,
  onListingChange,
  timeFilter,
  onTimeChange,
  communityFilter,
  onCommunityChange,
  communityOptions,
  loadingCommunity,
}) {
  const { isRootUser } = useAuthStore();

  return (
    <div className="bg-card p-4 rounded-2xl border border-border/50">
      <Row gutter={[12, 12]} align="middle">
        <Col xs={24} sm={10} md={7}>
          <Input.Search
            placeholder="Search events…"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            onSearch={onSearchChange}
            allowClear
          />
        </Col>
        <Col xs={12} sm={6} md={4}>
          <Select
            allowClear
            placeholder="Select Status"
            value={statusFilter}
            onChange={onStatusChange}
            options={STATUS_OPTIONS}
            style={{ width: "100%" }}
          />
        </Col>
        <Col xs={12} sm={6} md={4}>
          <Select
            allowClear
            placeholder={SHOW_IN_LISTINGS_COPY.filterPlaceholder}
            aria-label={SHOW_IN_LISTINGS_COPY.filterAriaLabel}
            value={listingFilter}
            onChange={onListingChange}
            options={LISTING_FILTER_OPTIONS}
            style={{ width: "100%" }}
          />
        </Col>
        {isRootUser && (
          <Col xs={12} sm={8} md={6}>
            <Select
              allowClear
              loading={loadingCommunity}
              value={communityFilter}
              onChange={onCommunityChange}
              options={communityOptions}
              style={{ width: "100%" }}
              showSearch
              optionFilterProp="label"
              placeholder="Select Community"
            />
          </Col>
        )}
        <Col xs={24} md={6}>
          <Segmented
            value={timeFilter}
            onChange={onTimeChange}
            options={TIME_OPTIONS}
          />
        </Col>
      </Row>
    </div>
  );
}

export default EventsFilterBar;
